module.exports = __webpack_public_path__ + "static/media/5.581c7a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/5.png
// module id = 853
// module chunks = 0